module.exports = __webpack_public_path__ + "img/gamifinna-yoga.fc8a612f.png";